import { baseenv } from './environment.base';
import { Environment } from './environment.model';

export const environment: Environment = {
  ...baseenv,
  okta: {
    SSOCredentials: {
      issuer: 'https://safeguard-uat.oktapreview.com/oauth2/aus2oug9jmJaurlRr1d7',
      clientId: '0oa85lnzbyJAVJBsB1d7', // MFA enabled
    },
  },
  production: false,
  baseHref: false,
  apiUrl: 'https://apiuica-uatdelta.sgdavinci.com',
  OAuthTokenApi: 'https://api-uat.yamahamotorprotectionplan.ca/token',
};
